import React from "react";
import { Card, CardBody } from "reactstrap";
import BGCStatusCounts from "./BGCCountCards/BGCStatusCounts";
import MOMBGCStatusCounts from "./BGCCountCards/MOMBGCStatusCounts";
import SCStatusCounts from "./BGCCountCards/SCStatusCounts";
import VisaStatusCounts from "./BGCCountCards/VisaStatusCounts";

function BGCStatusCountCard({ setStatus }) {
  return (
    <Card className="clearance-item mb-0">
      <CardBody className="elc-cardbody">
        <div className={"d-flex align-items-start w-100 flex-row gap-3"}>
          {/* Clearance */}
          <div
            hidden
            className="w-100 h-100 d-flex flex-column justify-content-around gap-2"
          >
            {/**BGC Start */}
            <BGCStatusCounts setStatus={setStatus} />
            {/**BGC End */}
            {/**MOM BGC Start */}
            <MOMBGCStatusCounts setStatus={setStatus} />
            {/**MOM BGC End */}
            {/** ------------------------------- */}
            {/**SC Start */}
            <SCStatusCounts setStatus={setStatus} />
            {/**SC End */}
            {/**Visa Start */}
            <VisaStatusCounts setStatus={setStatus} />
            {/**Visa End */}
          </div>
        </div>
      </CardBody>
    </Card>
  );
}

export default BGCStatusCountCard;
